import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
//import Login from '../';
import Tester from '../views/Tester.vue';
import Login from '../components/Login.vue';
import Admin from '../components/Admin.vue';
import Folders from '../components/Folders.vue';
import Folder from '../components/Folder.vue';
import LightAndTemperature from '../components/LightAndTemperature.vue';
import Calibration from '../components/Calibration.vue';
import Multimetr from '../components/Multimetr.vue';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },  
  {
    path: '/folders',
    name: 'Folders',    
    component: Folders
  },
  {
    path: '/folder',
    name: 'Folder',    
    component: Folder
  },
  {
    path: '/tester',
    name: 'Tester',    
    component: Tester
  },
  {
    path: '/login',
    name: 'Login',    
    component: Login
  },
  {
    path: '/admin',
    name: 'Admin',    
    component: Admin
  },
  {
    path: '/light',
    name: 'Light',    
    component: LightAndTemperature
  },
  {
    path: '/calibration',
    name: 'Calibration',    
    component: Calibration
  },
  {
    path: '/multimetr',
    name: 'Multimetr',    
    component: Multimetr
  },
]

const router = new VueRouter({
  routes
})

export default router
